import  React from 'react'
import { Fragment } from 'react'
import * as H from 'history'
import { IField, validateFieldsEx } from '../../../../shared/fields'
import { MilestoneReportModel } from '../../../../models/MilestoneReportModel'
import { DocumentTypeInfo, documentTypeInfo } from '../../documents/DocumentTypeInfo'
import { MilestoneReportDocumentSection } from '../../documents/DocumentSection'
import { MilestoneModel } from '../../../../models/MilestoneModel'
import EMDGAccordion from '../../../../shared/EMDGAccordion'

export interface Props {
    model: MilestoneReportModel
    onChange: { (changes: Partial<MilestoneModel>, callback?: { (): any }): any }
    history: H.History
    preview?: boolean
}

export interface State {

}

export default class SupportingDocumentationIndex extends React.Component<Props, State> {
  documents: { [code: string]: { [item: string]: MilestoneReportDocumentSection } }
  constructor(props: Props) {
    super(props)

    this.state = {

    }
  }

  componentDidUpdate(prevProps: Props) {
  }

  setDocumentRef(code: string, item: string, r: MilestoneReportDocumentSection) {
    if (!this.documents) {
      this.documents = {}
    }
    if (!this.documents[code]) {
      this.documents[code] = {}
    }
    this.documents[code][item] = r
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const documentsToValidate: IField[] = []

    for (const t of documentTypeInfo) {
      const items = t.reducer(this.props.model)
      for (const i of items) {
        if (this.documents && this.documents[t.code] && this.documents[t.code][i]) {
          documentsToValidate.push(this.documents[t.code][i])
        }
      }
    }

    validateFieldsEx(focus, callback,
      ...documentsToValidate)
  }

    getFilteredItems = (rptModel:MilestoneReportModel, info:DocumentTypeInfo) => {
        //27/Jul/2023: implement same bugfix on PDF as we did on UI last tab, see:  MilestoneReport/documents/DocumentSection.tsx;
        //additional filter by yearRange required;
        //convert year into yearRange, e.g. "2023" => "2022-23";
        //const year = rptModel.milestoneFinYearName;
        //const previousYear = Number(year) - 1;
        //const endingYear = year.slice(-2);
        //const yearRange = `${previousYear}-${endingYear}`;
        const startYear = (new Date(rptModel.milestoneModel.grantYearStartDate)).getFullYear();
        const endYear = (new Date(rptModel.milestoneModel.grantYearEndDate)).getFullYear().toString().slice(-2);
        const yearRange = `${startYear}-${endYear}`;

        var attachmentsArr = rptModel.milestoneModel.milestoneReportDocuments; //contains All attachments under the Application folder in Azure BLOB storage, not just for the chosen milestone Reports
        var filteredItems = attachmentsArr
            ? attachmentsArr.filter(item => {
                if (item.parentFolder === "07 Milestone Report") {
                    return item.code === info.code && item.folder.substr(-7) === yearRange; //folder= "Milestone Report 2022-23"
                } else {
                    return item.code === info.code;
                }
            })
            : [];
        return filteredItems;
    }

  render() {
    const {
      model, onChange, history, preview,
    } = this.props
    return (
      <div className="form-item">
        { preview && <h4>Supporting documentation</h4>}
        <EMDGAccordion expanded header="Supporting documentation">
          <div id="supportingDocumentSection">
            <>
              You should use the following naming convention for supporting documentation:
              {' '}
              <strong>WORD_WORD_WORD_Index.pdf</strong>
              . The maximum total number of characters for a file name is 144
              <br />
              <br />
              You must attach the following supporting documentation.
            </>
            {!preview ? (
              <>
                {documentTypeInfo.map((r) => (
                  <Fragment key={r.code}>
                    {r.reducer(model).map((i) => (
                      <MilestoneReportDocumentSection
                        key={i}
                        ref={(_) => this.setDocumentRef(r.code, i, _)}
                        model={model}
                        info={r}
                        item={i}
                        onChange={(milestoneReportDocuments) => onChange({ ...milestoneReportDocuments })}
                        history={history}
                      />
                    ))}
                  </Fragment>
                ))}
              </>
            ) : (
              <>
                <table className="table table-sm mt-3">
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Attached file</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentTypeInfo.map((r) => (
                      <Fragment key={r.code}>
                        {r.reducer(model).map((i) => (
                          <tr key={i}>
                            <td>{r.title}</td>
                            <td>
                              {/*model.milestoneModel.milestoneReportDocuments
                                .filter((d) => d.code === r.code)*/
                                this.getFilteredItems(model, r)
                                    .map((f, m, arr) => {
                                        const isLastItem = arr.length - 1 === m
                                        return (
                                            <Fragment key={m}>
                                                {`${f.documentName}${isLastItem ? '' : ',  '}`}
                                            </Fragment>
                                        )
                                    })
                              }
                            </td>
                          </tr>
                        ))}
                      </Fragment>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </EMDGAccordion>
      </div>
    )
  }
}
